<template>
  <div :style="`display: flex; flex-direction: ${util.getUserAgentMeta() === 'iOS application' ? 'column-reverse' : 'row'}; justify-content: center; align-items: center;`">
    <div style="display: flex; flex-direction: column;">
      <a
        :href="playStore"
        target="_blank"
        class="play-store"
        v-if="util.getUserAgentMeta() !== 'iOS application'"
      >
      </a>
      <a
        :href="appleStore"
        target="_blank"
        class="apple-store"
      >
      </a>
    </div>
    <img style="margin:8px; width: 96px; height: 96px;" :src="util.getImagePath('app_qr_code.png')" :srcset="util.getImageSet('app_qr_code')">
  </div>
</template>

<script>
export default {
  name: 'DownloadApp',
  data () {
    return {
      playStore: `https://play.google.com/store/apps/details?id=com.promptpai.promptpai&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1`,
      appleStore: `https://apps.apple.com/us/app/%E0%B8%9E%E0%B8%A3-%E0%B8%AD%E0%B8%A1%E0%B9%84%E0%B8%9B/id1479832893?mt=8`
    }
  }
}
</script>

<style scoped>
  .play-store {
    margin: 8px;
    display: inline-block;
    overflow: hidden;
    background: url(https://play.google.com/intl/en_us/badges/images/generic/en_badge_web_generic.png) no-repeat;
    width: 135px;
    height: 40px;
    background-size: auto 60px;
    background-position: -10px -10px;
  }

  .apple-store {
    margin: 8px;
    display: inline-block;
    overflow: hidden;
    background: url(/static/image/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg) no-repeat;
    height: 45px;
    background-size: cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/DownloadApp.vue